import { useEffect, useState } from 'react'
import { useTheme } from '@/theme-provider'

/** Resolves whether the document is currently using the dark theme (including system preference). */
export function useIsDarkMode(): boolean {
  const { theme } = useTheme()
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains('dark'))

  useEffect(() => {
    const sync = () => setIsDark(document.documentElement.classList.contains('dark'))
    sync()

    const observer = new MutationObserver(sync)
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })

    const media = window.matchMedia('(prefers-color-scheme: dark)')
    media.addEventListener('change', sync)

    return () => {
      observer.disconnect()
      media.removeEventListener('change', sync)
    }
  }, [theme])

  return isDark
}
